import { sessionService } from '@/providers/services/auth/session';
import { Vue, Component, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { mediaAPI } from '@/providers/apis/media/media';
import moment from 'moment';
import { isValidUrl } from '@/utils/utils';
import { communityHubAPI } from '@/providers/apis/community-hub/community-hub';


@Component({
    name: 'community-hub-create-page',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})
export default class CommunityHubCreateComponent extends Vue {

    public get session() {
        return sessionService.getSession();
    }

    // Properties
    public model = {
        title: '',
        description: '',
        uploadDetail: '',
        availableFrom: '',
        availableUntil: '',
        status: '',
    };
    public uploadData = {
        title: '',
        uploadContent: '',
    };

    @Prop()
    public isEdit!: boolean;

    public imageUrl: any;

    public selectedImage: any;

    public isEditing: boolean = false;

    public isAddContent: boolean = false;

    public uploadContents: any = [];

    public navItems = [
        {label: 'PDF', className: 'pdf', isActive: true, format: 'PDF', accept: '.pdf'},
        {label: 'Video', className: 'video', isActive: false, format: 'MP4', accept: '.mp4'},
        {label: 'Image', className: 'image', isActive: false, format: 'JPEG,JPG,PNG', accept: '.jpeg,.jpg,.png'},
        {label: 'HTML Content', className: 'html', isActive: false},
        {label: 'URL', className: 'url', isActive: false},
    ];

    public currentTab = 'PDF';

    public supportedFormat: any;

    public selectedContent: any;

    public progress: any = 0;

    public isUploading: boolean = false;

    public statusTypes = [
       'Active', 'In Active', 'Draft',
    ];

    public selectedStatus: any = null;

    public fetchHubContent: any = null;

    public validationMsg = false;

    public previewContent: any = null;

    public isUploadContent: boolean = false;

    public cdnUrls: any;

    public urlContent: any;

    public htmlContent: any;

    public previewUrl: any = '';

    public isValidTitle: boolean = false;

    public isFilevalid: boolean = false;

    public isValidHtmlContent: boolean = false;

    public isValidHtmlUrl: boolean = false;

    public isLoading: boolean = false;

    public isValidUrl: boolean = false;

    @Prop()
    private hubContent: any;

    public created() {
        const cdnUrls = sessionService.getCdnUrl();
        this.cdnUrls =  cdnUrls && cdnUrls.content_cdn_url;
        this.supportedFormat = this.navItems[0];
        if (this.hubContent) {
            this.fetchDetail();
        }
    }
    public onGoBack() {
        this.$emit('onCloseCreation');
    }
    public handleFileChange(e: any) {
        this.model.uploadDetail = e.target.files[0];
        this.selectedImage = e.target.files[0];
        const file = e.target.files[0];
        if (file && file.type.startsWith('image/')) {
            this.model.uploadDetail = URL.createObjectURL(file);
        }
    }
    public onPublish() {
        if (!this.model.title || !this.model.description  ||
            !this.model.availableUntil  || !this.model.availableFrom) {
            this.validationMsg = true;
            return;
        } else {
            this.validationMsg = false;
        }
        if (this.isEdit && this.hubContent.id) {
            const params: any = {};
            if (this.fetchHubContent.title !== this.model.title ) {
                params.title = this.model.title;
            }
            if (this.fetchHubContent.description !== this.model.description ) {
                params.description = this.model.description;
            }
            if (this.fetchHubContent.thumbnail !== this.model.uploadDetail ) {
                params.thumbnail = this.model.uploadDetail;
            }
            if (this.fetchHubContent.available_from !== this.model.availableFrom ) {
                params.available_from =  moment(this.model.availableFrom).format('YYYY/MM/DD');
            }
            if (this.fetchHubContent.available_until !== this.model.availableUntil ) {
                params.available_until = moment(this.model.availableUntil).format('YYYY/MM/DD');
            }
            if ( this.fetchHubContent &&  this.fetchHubContent.media &&
                 this.fetchHubContent.media.length &&  this.fetchHubContent.status !== 'active') {
                params.status = 'active';
            }
            this.isLoading = true;
            if (this.model.uploadDetail && this.fetchHubContent.thumbnail !== this.model.uploadDetail) {
                mediaAPI.uploadFile(this.selectedImage, 'image').then((imageData: any) => {
                    params.thumbnail = imageData.filename;
                    communityHubAPI.getUpdateCommunityHub(this.hubContent.id, params).then((res: any) => {
                        this.fetchDetail();
                    });
                });
            } else {
                communityHubAPI.getUpdateCommunityHub(this.hubContent.id, params).then((res: any) => {
                    this.fetchDetail();
                });
            }

        } else {
            this.isLoading = true;
            const params = {
                title:  this.model.title,
                description:  this.model.description,
                thumbnail: this.model.uploadDetail ? this.model.uploadDetail : '',
                available_from: this.model.availableFrom ?  moment(this.model.availableFrom).format('YYYY/MM/DD') : '',
                available_until: this.model.availableUntil ?  moment(this.model.availableUntil).format('YYYY/MM/DD') : '',
            };
            if (this.model.uploadDetail) {
                mediaAPI.uploadFile(this.selectedImage, 'image').then((imageData: any) => {
                    params.thumbnail = imageData.filename;
                    communityHubAPI.getcommunityHubCreate(params).then((res: any) => {
                        this.onGoBack();
                        this.fetchDetail();
                    });
                });
            } else {
                communityHubAPI.getcommunityHubCreate(params).then((res: any) => {
                    this.onGoBack();
                    this.fetchDetail();
                });
            }
        }
    }
    public onEdit() {
        this.isEditing = true;
    }

    public onCancel() {
        this.isEditing = false;
    }

    public addContent() {
        this.isAddContent = true;
    }
    public onChangeNav(item: any) {
        this.supportedFormat = item;
        this.currentTab = item.label;
        this.isValidTitle = false;
        this.isFilevalid = false;
        this.uploadData = {
            title: '',
            uploadContent: '',
        };
        this.urlContent = '';
        this.htmlContent = '';
        this.navItems.map((data: any) => {
            if (data.label === item.label) {
                data.isActive = true;
            } else {
                data.isActive = false;
            }
        });
    }
    public handleFileUpload(e: any) {
        if (e.target.files[0] && e.target.files[0].size > 5 * 1024 * 1024 * 1024) { // 5GB in bytes
            alert('File size exceeds 5GB');
            e.preventDefault();
        }
        this.uploadData.uploadContent = e.target.files[0];
        this.selectedContent = e.target.files[0];
        this.selectedContent.contentType = this.selectedContent.type === 'application/pdf' ?
        this.selectedContent.type.split('/')[1] : this.selectedContent.type.split('/')[0];
        this.uploadContents.push(this.selectedContent);
        this.isUploading = true;
        this.progress = 0;
        for (let i = 0; i < 100; i++) {
            this.progress = i;
          }
        if (this.selectedContent) {
            this.isFilevalid = false;
            mediaAPI.uploadFile(this.selectedContent, 'image').then((res: any) => {
                this.progress = 100;
                this.isUploading = false;
                this.uploadContents.map((content: any) => {
                    if (content.name === res.original_filename) {
                        content.fileName = res.filename;
                        content.original_filename = res.original_filename;
                        content.mediaUrl = res.filename;
                        content.mediaType = content.contentType;
                    }
                });
                e.target.files[0] = null;
                this.selectedContent = null;
            });
        }

    }
    public finishUpload() {
        const uploadParam: any = [];
        if ( this.uploadData && !this.uploadData.title) {
            this.isValidTitle = true;
            return;
        } else {
            this.isValidTitle = false;
        }
        if ( this.uploadData &&  !this.uploadData.uploadContent  && this.currentTab  !== 'URL' && this.currentTab  !== 'HTML Content') {
            this.isFilevalid = true;
            return;
        } else {
            this.isFilevalid = false;
        }
        if (this.currentTab === 'HTML Content') {
            if ( !this.htmlContent) {
                this.isValidHtmlContent = true;
                return;
            }
            const params = {
                title:  this.uploadData.title,
                media_type: 'html',
                media_url: this.htmlContent,
                sequence_id: 1,
            };
            uploadParam.push(params);
        }

        if (this.currentTab  === 'URL') {
            if ( !this.urlContent) {
                this.isValidHtmlUrl = true;
                return;
            }
            if (!isValidUrl(this.urlContent)) {
                this.isValidUrl = true;
                return;
            }
            const params = {
                title:  this.uploadData.title,
                media_type: 'url',
                media_url: this.urlContent,
                sequence_id: 1,
            };
            uploadParam.push(params);
        }
        if (this.uploadContents) {
            this.uploadContents.map((content: any, index: number) => {
                const params = {
                    title:  this.uploadData.title,
                    media_type: content.contentType,
                    media_url: content.fileName,
                    sequence_id: index + 1,
                };
                uploadParam.push(params);
            });
        }
        this.isLoading = true;
        communityHubAPI.getCreateHubContent(this.hubContent.id, uploadParam).then((res: any) => {
            this.isUploadContent = false;
            this.isLoading = false;
            this.fetchDetail();
            this.uploadContents = [];
            this.uploadData = {
                title: '',
                uploadContent: '',
            };
            this.currentTab = 'PDF';
            this.navItems.map((data: any) => {
                if (data.label === this.currentTab) {
                    data.isActive = true;
                } else {
                    data.isActive = false;
                }
            });
        });
    }
    public onPreview(content: any) {
        this.previewContent = content;
        this.previewUrl = this.cdnUrls + content.mediaUrl;
        this.$bvModal.show('previewContents');
    }
    public hideConfirmationModal() {
        this.previewContent = null;
        this.previewUrl = null;
        this.$bvModal.hide('previewContents');
    }
    public onUploadContents() {
        this.isUploadContent = true;
    }
    public onUpdateClose() {
        this.isUploadContent = false;
        this.currentTab = 'PDF';
        this.uploadContents = [];
        this.navItems.map((data: any) => {
            if (data.label === this.currentTab) {
                data.isActive = true;
                this.onChangeNav(data);
            } else {
                data.isActive = false;
            }
        });
    }
    public fetchDetail() {
        this.isLoading = true;
        const cdnUrls = sessionService.getCdnUrl();
        communityHubAPI.getHubDetail(this.hubContent.id).then((res: any) => {
            this.isEditing = false;
            this.fetchHubContent = res;
            res.availableUntil = moment(res.available_until).format('YYYY/MM/DD');
            res.availableFrom = moment(res.available_from).format('YYYY/MM/DD');
            res.available_from = new Date(res.available_from);
            res.available_until = new Date(res.available_until);
            const containsCdnUrl = res.thumbnail.indexOf('https') !== -1;
            if (!containsCdnUrl) {
                res.thumbnail = res.thumbnail ? cdnUrls.content_cdn_url + res.thumbnail : '';
            } else {
                res.thumbnail = res.thumbnai ? res.thumbnail : '';
            }
            this.model = {
                title: res.title,
                description: res.description,
                uploadDetail: res.thumbnail,
                availableFrom: res.available_from,
                availableUntil: res.available_until,
                status: res.status,
            };
            this.isLoading = false;
        });
    }
    public onDeleteUpdateContent(content: any) {
        const contentId = content.id;
        communityHubAPI.removeHubContent(this.hubContent.id, contentId, {}).then((res: any) => {
            this.fetchDetail();
        });
    }
    public onDeleteHub() {
        this.isLoading = true;
        communityHubAPI.removeHub(this.fetchHubContent.id, {}).then((res: any) => {
            this.isLoading = false;
            this.onGoBack();
        });
    }
    public onUploadDelete(content: any) {
        this.uploadContents = this.uploadContents.filter((data: any) => {
            return data.original_filename !== content.original_filename;
        });
    }
    public disabledDate(date: any) {
        return date && date < new Date().setHours(0, 0, 0, 0);
    }
    public onDeleteConfirmationPopup() {
        this.$bvModal.show('confirmation-delete');
    }
    public hideDeleteConfirmationModal() {
        this.$bvModal.hide('confirmation-delete');
    }
    public inputOnChange(event: any, type: any = false) {
        this.isValidTitle = false;
        if (type === 'url') {
            this.isValidHtmlUrl = false;
            this.isValidUrl = false;
        }
    }
}
